<template>
  <div class="home">
    <template v-if="user && !completedStudyWithJobPreferences">
      <exchange-study-not-completed />
    </template>
    <job-profiles-list v-else />
    <b-modal
      id="job-profile-modal"
      ref="modal"
      :hide-footer="true"
      content-class="rounded-0"
      body-class="pb-4"
    >
      <div slot="modal-title">
        <span class="card_title">Create Ideal Career Opportunity</span>
      </div>
      <job-profile-form
        @cancel="$refs.modal.hide()"
        @form-submit="onNewJobProfile"
      />
    </b-modal>
  </div>
</template>

<script>
import JobProfileForm from '@/components/exchange/JobProfileForm';
import JobProfilesList from '@/components/exchange/job-profiles-list/JobProfilesListV3';
import { CREATE_JOB_PROFILE_ACTION } from '@/store/jobProfiles';
import { handleServerErrorWithValidation } from '@/helpers/ToastedHelper';
import ExchangeStudyNotCompleted from '@/components/exchange/ExchangeStudyNotCompleted';

export default {
  name: 'ExchangeHome',
  components: {
    JobProfileForm,
    JobProfilesList,
    ExchangeStudyNotCompleted,
  },
  computed: {
    user: function () {
      return this.$store.state.user;
    },
    completedStudyWithJobPreferences: function () {
      return this.user && this.user.completedStudyWithJobPreferences;
    },
  },
  methods: {
    onNewJobProfile: async function (title) {
      try {
        const newProfile = await this.$store.dispatch(
          CREATE_JOB_PROFILE_ACTION,
          {
            title,
          }
        );
        this.$refs.modal.hide();
        this.$router.push({
          name: `jobProfilePage`,
          params: {
            isNew: true,
            id: (newProfile || {}).id,
          },
        });
      } catch (error) {
        handleServerErrorWithValidation(error, this.$toasted);
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import '../../../sass/variables_mixins';

.border-none {
  border: none !important;
}

.card_title {
  @include phairify_heading_bold_18;
  color: $phairify_primary_color_navy;
}
</style>
